import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import React from "react";
import { Body } from "./Typography";
import { CopyableRow } from "./CopyableRow";

const useStyles = createStyles(() => ({
  subtleText: {
    color: tokens.color.semantic.text.subtle,
  },
  monoId: {
    fontFamily: tokens.font.family.mono,
    // Long ids wrap across lines instead of forcing horizontal scroll.
    wordBreak: "break-all" as const,
  },
}));

/** A subtitle identifier line: "<label>: <mono value>" with a copy control. */
export const IdLine: React.FC<{ label: string; value: string; testId: string; copyTestId: string }> = ({
  label,
  value,
  testId,
  copyTestId,
}) => {
  const { classes } = useStyles();
  return (
    <CopyableRow value={value} overflow="none" size="base" copyTestId={copyTestId}>
      <Body size="sm" className={classes.subtleText} data-testid={testId}>
        <Body as="span" size="sm" weight="semibold">
          {label}:
        </Body>{" "}
        <Body as="span" size="sm" className={classes.monoId}>
          {value}
        </Body>
      </Body>
    </CopyableRow>
  );
};
